import state from "@/store/modules/user-group/state";
import actions from "@/store/modules/user-group/actions";
import mutations from "@/store/modules/user-group/mutations";
import getters from "@/store/modules/user-group/getters";

export default {
    state,
    actions,
    mutations,
    getters
}